import React from 'react';
import { toPattern, toNumber } from 'vanilla-masker';
import { isValidPhone } from '@brazilian-utils/brazilian-utils';
import whatsapp from 'assets/svg/whatsapp-green.svg';
import '../assets/share-url.styles.scss';

type WhatsAppFormProps = {
    whatsappMessage: string;
    label?: string;
    className?: string;
    onSent(): void;
    onClick(): void;
};

const WhatsAppForm: React.FC<WhatsAppFormProps> = ({ whatsappMessage, label, className, onSent, onClick }): JSX.Element => {
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const [validPhone, setValidPhone] = React.useState(false);

    const submit = (event: React.FormEvent) => {
        event.preventDefault();

        window.open(`https://wa.me/55${toNumber(phoneNumber)}?text=${encodeURI(whatsappMessage)}`);

        onSent();
    }

    return (
        <div className={`c-partner-link-form ${className || ''}`.trim()}>
            <div className="c-partner-link-form__icon">
                <img src={whatsapp} className="mb-2" role='presentation' />
                <p className="body-2 lg:body-1 medium">WhatsApp</p>
            </div>
            <form className="c-partner-link-form__form" onSubmit={submit}>
                <label className="caption">{label || 'Digite o número do telefone'}</label>
                <input
                    value={phoneNumber}
                    onChange={(event) => {
                        const { target: { value } } = event;
                        const phonePattern = value && value.length > 14
                            ? '(99) 99999-9999'
                            : '(99) 9999-9999';

                        setPhoneNumber(toPattern(value || '', phonePattern));
                        setValidPhone(isValidPhone(value));
                    }}
                />
                <button
                    type="submit"
                    disabled={!validPhone}
                    onClick={ () => {
                        if(onClick) {
                            onClick()
                        }
                    }}>
                    Enviar
                </button>
            </form>
        </div>
    );
};

export default WhatsAppForm;
